<app-browser-header
  #browserHeader
  [searchPlaceholder]="name ? ('VENDOR_SEARCH_PAGE.SEARCH_IN_VENDOR' | translate : { vendor: name }) : null"
  [emitSearchSelectedEvent]="true"
  (searchSelected)="onOpenSearch()"
>
</app-browser-header>

<div
  class="main-header"
  [class.with-navbar-background]="showCordovaHeaderBackground"
  [class.with-shadow]="showCordovaHeaderBackground && !isTabBarFixedAtTop"
>
  <div #cordovaHeader class="navbar" [class.with-padding-top]="showNavbarPaddingTop">
    <div class="navbar-start">
      <ion-button color="white" class="navbar-button" data-cy="back-button" (click)="onNavigateBack()">
        <ion-icon class="navbar-button-icon back-icon" src="/assets/custom-icons/shared/back-icon.svg"></ion-icon>
      </ion-button>
    </div>
    <div class="navbar-center">
      <div class="navbar-title">{{ name }}</div>
    </div>
    <div class="navbar-end">
      <ion-button color="white" data-cy="search-button" class="navbar-button search-button" (click)="onOpenSearch()">
        <ion-icon class="navbar-button-icon search-icon" src="/assets/custom-icons/shared/search-icon.svg"></ion-icon>
      </ion-button>

      <ion-button color="white" data-cy="share-button" class="navbar-button share-button" (click)="onShare()">
        <ion-icon class="navbar-button-icon share-icon" src="/assets/custom-icons/shared/share.svg"></ion-icon>
      </ion-button>
    </div>
  </div>
</div>

<div
  tappable
  class="chat-button"
  *ngIf="!!chatPhoneNumber && !!name"
  [class.expanded]="showChatButtonExpanded"
  [class.with-footer]="cartItemsCount && !isBrowser"
  [class.with-footer-and-min-order]="cartItemsCount && !isBrowser && amountRemainingToMinimumOrderValue"
  (click)="onOpenVendorChat()"
>
  <div class="chat-button-icon-container">
    <ion-icon class="chat-button-icon" icon="/assets/custom-icons/whatsapp.svg"></ion-icon>
  </div>
  <div
    class="chat-button-content"
    *ngIf="showChatButtonExpanded"
    @animatedChatButtonContent
    (@animatedChatButtonContent.start)="onChatButtonAnimationStart()"
    (@animatedChatButtonContent.done)="onChatButtonAnimationEnd()"
  >
    <div class="chat-button-text-container animated-text-container">
      <!-- We use the hidden text to adjust the width of the container before making the "visible" text to appear on top -->
      <p class="chat-button-text hidden" [innerHTML]="'VENDOR_CHAT_BUTTON_TEXT' | translate : { vendorName: name }"></p>
      <p
        *ngIf="showChatButtonExpanded"
        class="chat-button-text visible animated-text"
        [innerHTML]="'VENDOR_CHAT_BUTTON_TEXT' | translate : { vendorName: name }"
      ></p>
    </div>
  </div>
</div>

<ion-content [fullscreen]="!isBrowser" [scrollEvents]="true" (ionScroll)="onScroll($event)">
  <ng-container *ngIf="!isBrowser && !isCordovaTablet">
    <div slot="fixed" class="header-image-background" [style.height.px]="headerImageMinHeight"></div>
    <div slot="fixed" #headerImage class="header-image" [style.height.px]="headerImageMinHeight"></div>
    <div slot="fixed" class="header-image-foreground"></div>
  </ng-container>

  <ion-grid class="page-container" fixed>
    <div [style.marginTop.px]="contentMarginTop" [style.minHeight.px]="contentMinHeight" class="content">
      <div data-cy="loading-spinner" class="loading-container" *ngIf="!showVendorDetails">
        <ion-spinner name="dots"></ion-spinner>
      </div>

      <div class="vendor-content" *ngIf="showVendorDetails" [class.hidden]="hideVendorDetails">
        <div @animatedContent class="vendor-info">
          <div tappable *ngIf="isBrowser" class="go-back" (click)="onNavigateBack()">
            <ion-icon class="go-back-icon" src="/assets/custom-icons/shared/back-icon.svg"></ion-icon>
            <div class="go-back-text">{{ "ALL_VENDORS" | translate }}</div>
          </div>

          <div #vendorName class="vendor-name">{{ name }}</div>

          <div class="badges">
            <div *ngIf="isSelectedServiceTypeBasedOnDateTime" tappable class="vendor-date-time-badge" (click)="onOpenDateTimePicker()">
              <span *ngIf="isOrderForNowSelected">{{ "NOW" | translate }}</span>
              <span *ngIf="!isOrderForNowSelected && selectedDateTime">
                {{ selectedDateTime | formatDateTime : { format: "MMM DD HH:mm" } }}
              </span>
              <span *ngIf="!isOrderForNowSelected && !selectedDateTime">{{ "WHEN" | translate }}</span>
            </div>

            <div tappable class="vendor-rating-badge" *ngIf="rating?.overall > 0" (click)="onOpenReviews()">
              <ion-icon class="vendor-rating-icon" src="/assets/custom-icons/shared/star.svg"></ion-icon>
              <span>{{ rating.overall | number : "1.2-2" }}</span>
              <ng-container *ngIf="rating.overallMax">
                <span class="vendor-rating-secondary-info separator">/</span>
                <span class="vendor-rating-secondary-info">{{ rating.overallMax }}</span>
              </ng-container>
              <span class="vendor-rating-secondary-info">&nbsp;({{ rating.countRange }})</span>
            </div>

            <div *ngIf="minEta" tappable class="vendor-eta-badge" (click)="onOpenETA()">{{ minEta.title }}</div>

            <div tappable data-cy="vendor-delivery-charge-badge" class="vendor-delivery-badge" (click)="onOpenDeliveryInfo()">
              <span *ngIf="minimumDeliveryCharge === 0 && sameDeliveryAcrossServiceTypes">
                {{ "VENDOR_DETAILS_PAGE.FREE" | translate | titlecase }} {{ "CART_PAGE.DELIVERY_CHARGES" | translate | titlecase }}
              </span>

              <span *ngIf="minimumDeliveryCharge === 0 && !sameDeliveryAcrossServiceTypes">
                {{ "CART_PAGE.DELIVERY_CHARGES" | translate | titlecase }} {{ "FIELDS.FROM" | translate | lowercase }}
                {{ 0 | localCurrency }}
              </span>

              <span *ngIf="minimumDeliveryCharge > 0 && sameDeliveryAcrossServiceTypes">
                {{ "CART_PAGE.DELIVERY_CHARGES" | translate | titlecase }} {{ minimumDeliveryCharge | localCurrency }}
              </span>

              <span *ngIf="minimumDeliveryCharge > 0 && !sameDeliveryAcrossServiceTypes">
                {{ "CART_PAGE.DELIVERY_CHARGES" | translate | titlecase }} {{ "FIELDS.FROM" | translate | lowercase }}
                {{ minimumDeliveryCharge | localCurrency }}
              </span>

              <span *ngIf="minimumDeliveryCharge === undefined || minimumDeliveryCharge === null">
                {{ "CART_PAGE.DELIVERY_CHARGES" | translate | titlecase }}
                {{ "VENDOR_DETAILS_PAGE.VARIES_BY_AREA" | translate | lowercase }}
              </span>
            </div>

            <div tappable data-cy="vendor-min-order-badge" class="vendor-min-order-badge" (click)="onOpenMinOrderInfo()">
              <span *ngIf="minOrderValue === 0 && sameMinOrderValueAcrossServiceTypes">
                {{ "VENDOR_DETAILS_PAGE.NO_MINIMUM_ORDER_VALUE" | translate | titlecase }}
              </span>

              <span *ngIf="minOrderValue === 0 && !sameMinOrderValueAcrossServiceTypes">
                {{ "VENDOR_DETAILS_PAGE.MINIMUM_ORDER_INFO" | translate | titlecase }} {{ "FIELDS.FROM" | translate | lowercase }}
                {{ 0 | localCurrency }}
              </span>

              <span *ngIf="minOrderValue > 0 && sameMinOrderValueAcrossServiceTypes">
                {{ "VENDOR_DETAILS_PAGE.MINIMUM_ORDER_INFO" | translate | titlecase }} {{ minOrderValue | localCurrency }}
              </span>

              <span *ngIf="minOrderValue > 0 && !sameMinOrderValueAcrossServiceTypes">
                {{ "VENDOR_DETAILS_PAGE.MINIMUM_ORDER_INFO" | translate | titlecase }} {{ "FIELDS.FROM" | translate | lowercase }}
                {{ minOrderValue | localCurrency }}
              </span>

              <span *ngIf="minOrderValue === undefined || minOrderValue === null">
                {{ "VENDOR_DETAILS_PAGE.MINIMUM_ORDER_INFO" | translate | titlecase }}
                {{ "VENDOR_DETAILS_PAGE.VARIES_BY_AREA" | translate | lowercase }}
              </span>
            </div>

            <div *ngIf="policy" tappable class="vendor-policy-badge" (click)="onOpenPolicyInfo()">
              <ion-icon src="/assets/custom-icons/vendor-details-page/information.svg"></ion-icon>
            </div>

            <div *ngIf="isBrowser" tappable class="vendor-share-badge" (click)="onShare()">
              <ion-icon src="/assets/custom-icons/shared/share.svg"></ion-icon><span>{{ "SHARE" | translate }} </span>
            </div>

            <div
              class="vendor-info-badge"
              *ngFor="let badge of badges"
              [style.color]="badge.foreColor"
              [style.backgroundColor]="badge.backColor"
            >
              <ion-icon *ngIf="badge.iconUrl" class="vendor-info-badge-icon" [src]="badge.iconUrl"></ion-icon>
              {{ badge.text }}
            </div>
          </div>

          <div
            tappable
            class="alternative-service-types"
            *ngIf="alternativeServiceTypeAvailableDetails && !isFilteringItems"
            (click)="onOpenDifferentServiceTypeInNewTab(alternativeServiceTypeAvailableDetails.serviceType)"
          >
            <div class="alternative-service-type-icon-container">
              <div class="alternative-service-type-outer-circle"></div>
              <div class="alternative-service-type-inner-circle"></div>
              <ion-icon class="alternative-service-type-icon" name="search"></ion-icon>
            </div>
            <div class="alternative-service-type-details">
              <p class="alternative-service-types-title">{{ "VENDOR_DETAILS_PAGE.ALTERNATIVE_SERVICE_TYPE_TITLE" | translate }}</p>
              <p class="alternative-service-types-message" [innerHTML]="alternativeServiceTypeAvailableDetails.message"></p>
            </div>
          </div>

          <div class="filtered-items" *ngIf="isBrowser && isFilteringItems">
            <p
              class="filtered-items-message"
              [innerHTML]="'VENDOR_DETAILS_PAGE.SHOWING_ITEMS_MATCHING_TAGS' | translate : { tagsNames: selectedTagsNames }"
            ></p>
            <div tappable class="filtered-items-button" (click)="onViewAllItems()">
              {{ "VENDOR_DETAILS_PAGE.VIEW_ALL_ITEMS" | translate }}
            </div>
          </div>

          <!-- Announcements are not returned from the API for grocery vendors -->
          <div
            *ngIf="vendorDetails && vendorDetails.announcements && vendorDetails.announcements[0] && vendorDetails.announcements[0].message"
            class="vendor-announcement"
            [innerHTML]="vendorDetails.announcements[0].message"
          ></div>
        </div>

        <div @animatedContent *ngIf="!previousOrders.length && !isBrowser && !isCordovaTablet" class="section-separator"></div>

        <ng-container *ngIf="previousOrders.length">
          <div
            *ngIf="!isBrowser"
            @animatedContent
            class="previous-orders-section"
            [class.no-description]="allPreviousOrdersHaveOnlyOneItem"
          >
            <div class="previous-orders-wrapper">
              <div class="previous-orders">
                <div *ngFor="let order of previousOrders" class="previous-order">
                  <div class="order-title">{{ order.title }}</div>
                  <div class="order-description" *ngIf="order.description">{{ order.description }}</div>
                  <div class="order-info">
                    {{ order.totalPrice | localCurrency }}
                    <span> &bull; </span>
                    {{ order.deliveryDateFormatted }}
                  </div>

                  <div tappable class="order-button" (click)="onOpenPreviousOrderModal(order)">
                    {{ "VENDOR_DETAILS_PAGE.REORDER" | translate }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <swiper
            #swiper
            *ngIf="isBrowser"
            @animatedContent
            class="horizontal-list"
            [class.no-description]="allPreviousOrdersHaveOnlyOneItem"
            [dir]="sliderScrollingDirection"
            [config]="sliderConfig"
          >
            <ng-template swiperSlide *ngFor="let order of previousOrders">
              <div class="previous-order">
                <div class="order-title">{{ order.title }}</div>
                <div class="order-description" *ngIf="order.description">{{ order.description }}</div>
                <div class="order-info">
                  {{ order.totalPrice | localCurrency }}
                  <span> &bull; </span>
                  {{ order.deliveryDateFormatted }}
                </div>

                <div tappable class="order-button" (click)="onOpenPreviousOrderModal(order)">
                  {{ "VENDOR_DETAILS_PAGE.REORDER" | translate }}
                </div>
              </div>
            </ng-template>
          </swiper>
        </ng-container>

        <div @animatedContent class="items-container">
          <div class="quick-search" tappable (click)="onOpenSearch()" *ngIf="!isSelectedServiceTypeBasedOnCategories && !isFilteringItems">
            <ion-icon src="/assets/custom-icons/vendor-details-page/search.svg"></ion-icon>
            <span>{{ "VENDOR_SEARCH_PAGE.SEARCH_IN_VENDOR" | translate : { vendor: name } }}</span>
          </div>

          <!-- This element is used to check if the tabs bar is fixed at the top or not-->
          <div #groupsTabsSentinel style="height: 1px"></div>

          <!-- 
            Background only used in the browser when the sticky tabs are fixed to the top
            because we need it to use the entire width of the screen even though it's nested
            in the ion-grid element
           -->
          <div
            @animatedTabBarBackground
            *ngIf="isBrowser && isTabBarFixedAtTop"
            class="browser-tabbar-background"
            [style.height.px]="tabbarHeight"
          ></div>

          <div
            #groupsTabs
            class="tabs-wrapper"
            [class.with-shadow]="isTabBarFixedAtTop"
            [class.with-background]="!isBrowser || !isTabBarFixedAtTop"
            [style.top.px]="isBrowser ? 0 : cordovaHeaderHeight || 0"
            [style.height.px]="tabbarHeight + (!isBrowser && isFilteringItems ? filteredItemsSectionHeight : 0)"
          >
            <div *ngIf="!isBrowser && isFilteringItems" class="tabs-wrapper-row">
              <div class="filtered-items">
                <p
                  class="filtered-items-message"
                  [innerHTML]="'VENDOR_DETAILS_PAGE.SHOWING_ITEMS_MATCHING_TAGS' | translate : { tagsNames: selectedTagsNames }"
                ></p>
                <div tappable class="filtered-items-button" (click)="onViewAllItems()">
                  {{ "VENDOR_DETAILS_PAGE.VIEW_ALL_ITEMS" | translate }}
                </div>
              </div>
            </div>
            <div class="tabs-wrapper-row" [style.height.px]="tabbarHeight">
              <div *ngIf="!isBrowser" tappable class="tabs-side-menu-button" (click)="onOpenGroupsSideMenu()">
                <ion-icon
                  class="tabs-side-menu-button-icon"
                  src="/assets/custom-icons/vendor-details-page/categories-hamburger-icon.svg"
                ></ion-icon>
              </div>
              <div class="tabs">
                <div
                  tappable
                  class="tab-wrapper"
                  [class.active]="activeTabIndex === i"
                  (click)="onChangeTab(i)"
                  *ngFor="let tab of tabs; index as i"
                >
                  <div class="tab">
                    <div class="tab-name">{{ tab.name }}</div>
                    <div class="tab-service-type">{{ tab.serviceTypeName ?? ("ALL_SERVICES" | translate) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="!isSelectedServiceTypeBasedOnCategories" #vendorMenuGroups class="items">
            <app-vendor-menu-groups
              [vendorDetails]="vendorDetails"
              [quickAddToCart]="isQuickAddToCartSupported"
              (menuItemSelected)="onMenuItemSelected($event)"
              (menuItemDecremented)="onMenuItemDecremented($event)"
              (menuItemIncremented)="onMenuItemIncremented($event)"
              (menuItemAvailabilityRequested)="onMenuItemAvailabilityRequested($event)"
              (menuGroupsRendered)="onMenuGroupsRendered($event)"
            ></app-vendor-menu-groups>
          </div>

          <div *ngIf="isSelectedServiceTypeBasedOnCategories" class="items">
            <app-vendor-grocery-categories
              [serviceType]="selectedServiceTypes"
              [address]="selectedAddress"
              [vendorDetails]="groceryVendorDetails"
              [categories]="categoryDetails.items"
              (groceryCategoriesRendered)="onGroceryCategoriesRendered($event)"
            ></app-vendor-grocery-categories>
          </div>

          <div id="groupsBottomSpacing" style="width: 100%; height: 1px; opacity: 0"></div>
        </div>
      </div>
    </div>
  </ion-grid>

  <app-browser-footer></app-browser-footer>
</ion-content>

<ion-footer #footer @animatedFooter (@animatedFooter.done)="onFooterChange()" *ngIf="cartItemsCount && !isBrowser" class="animated-footer">
  <ion-toolbar fixed>
    <app-view-order-button
      data-cy="view-order-button"
      [activeVendorId]="vendorId"
      (click)="onViewOrder()"
      (resizeContent)="onFooterChange()"
    ></app-view-order-button>
  </ion-toolbar>
</ion-footer>

<ng-template #vendorEtaContent>
  <div class="vendor-eta-title">{{ minEta.title }}</div>
  <div class="vendor-eta-message">{{ minEta.description }}</div>
</ng-template>

<ion-modal class="vendor-eta auto-height" *ngIf="isBrowser && minEta" [isOpen]="isETAOpen" (didDismiss)="isETAOpen = false">
  <ng-template>
    <div class="inner-content"><ng-template [ngTemplateOutlet]="vendorEtaContent"></ng-template></div>
  </ng-template>
</ion-modal>

<ion-modal
  class="vendor-eta"
  *ngIf="!isBrowser && minEta"
  [isOpen]="isETAOpen"
  (didDismiss)="isETAOpen = false"
  [breakpoints]="[0, 0.35, 0.5]"
  [initialBreakpoint]="0.35"
>
  <ng-template>
    <ion-content><ng-template [ngTemplateOutlet]="vendorEtaContent"></ng-template></ion-content>
  </ng-template>
</ion-modal>

<ng-template #vendorDeliveryContent>
  <div class="vendor-delivery-info-title">{{ "VENDOR_DETAILS_PAGE.DELIVERY_INFORMATION" | translate }}</div>
  <div class="vendor-delivery-info-row" *ngFor="let delivery of deliveryInfo">
    <span *ngIf="delivery.minOrderValue">{{
      "VENDOR_DETAILS_PAGE.DELIVERY_CHARGES"
        | translate : { serviceType: delivery.serviceTypeName, mov: delivery.minOrderValue | localCurrency }
    }}</span>

    <span *ngIf="!delivery.minOrderValue">{{
      "VENDOR_DETAILS_PAGE.DELIVERY_CHARGES_WITHOUT_MOV" | translate : { serviceType: delivery.serviceTypeName }
    }}</span>

    <span *ngIf="delivery.minimumDeliveryCharge">{{ delivery.minimumDeliveryCharge | localCurrency }}</span>
    <span *ngIf="delivery.minimumDeliveryCharge === 0">{{ "VENDOR_DETAILS_PAGE.FREE" | translate }}</span>
    <span *ngIf="delivery.minimumDeliveryCharge === undefined || delivery.minimumDeliveryCharge === null">{{
      "VENDOR_DETAILS_PAGE.VARIES_BY_AREA" | translate
    }}</span>
  </div>
</ng-template>

<ion-modal
  class="vendor-delivery-info auto-height"
  *ngIf="isBrowser && deliveryInfo?.length"
  [isOpen]="isVendorDeliveryInfoOpen"
  (didDismiss)="isVendorDeliveryInfoOpen = false"
>
  <ng-template>
    <div class="inner-content"><ng-template [ngTemplateOutlet]="vendorDeliveryContent"></ng-template></div>
  </ng-template>
</ion-modal>

<ion-modal
  class="vendor-delivery-info"
  *ngIf="!isBrowser && deliveryInfo?.length"
  [isOpen]="isVendorDeliveryInfoOpen"
  (didDismiss)="isVendorDeliveryInfoOpen = false"
  [breakpoints]="[0, 0.35, 0.5]"
  [initialBreakpoint]="0.35"
>
  <ng-template>
    <ion-content><ng-template [ngTemplateOutlet]="vendorDeliveryContent"></ng-template></ion-content>
  </ng-template>
</ion-modal>

<ng-template #vendorMinOrderContent>
  <div class="vendor-min-order-info-title">{{ "VENDOR_DETAILS_PAGE.MINIMUM_ORDER_VALUE" | translate }}</div>
  <div class="vendor-min-order-info-row" *ngFor="let delivery of deliveryInfo">
    <span>{{ delivery.serviceTypeName }}</span>

    <span *ngIf="delivery.minOrderValue">{{ delivery.minOrderValue | localCurrency }}</span>
    <span *ngIf="delivery.minOrderValue === 0">{{ "VENDOR_DETAILS_PAGE.FREE" | translate }}</span>
    <span *ngIf="delivery.minOrderValue === undefined || delivery.minOrderValue === null">{{
      "VENDOR_DETAILS_PAGE.VARIES_BY_AREA" | translate
    }}</span>
  </div>
</ng-template>

<ion-modal
  class="vendor-min-order-info auto-height"
  *ngIf="isBrowser && deliveryInfo?.length"
  [isOpen]="isVendorMinOrderInfoOpen"
  (didDismiss)="isVendorMinOrderInfoOpen = false"
>
  <ng-template>
    <div class="inner-content"><ng-template [ngTemplateOutlet]="vendorMinOrderContent"></ng-template></div>
  </ng-template>
</ion-modal>

<ion-modal
  class="vendor-min-order-info"
  *ngIf="!isBrowser && deliveryInfo?.length"
  [isOpen]="isVendorMinOrderInfoOpen"
  (didDismiss)="isVendorMinOrderInfoOpen = false"
  [breakpoints]="[0, 0.35, 0.5]"
  [initialBreakpoint]="0.35"
>
  <ng-template>
    <ion-content><ng-template [ngTemplateOutlet]="vendorMinOrderContent"></ng-template></ion-content>
  </ng-template>
</ion-modal>

<ng-template #vendorPolicyContent>
  <div class="vendor-policy-title">{{ "VENDOR_DETAILS_PAGE.VENDOR_POLICY" | translate }}</div>
  <div class="vendor-policy-hours">
    <span>{{ "VENDOR_DETAILS_PAGE.OPENING_HOURS" | translate }}: </span> {{ openingTime | formatDateTime : { format: "hh:mm a" } }} -
    {{ closingTime | formatDateTime : { format: "hh:mm a" } }}
  </div>
  <div class="vendor-policy-message" [innerHtml]="policy"></div>
</ng-template>

<ion-modal
  class="vendor-policy auto-height"
  *ngIf="isBrowser && policy"
  [isOpen]="isVendorPolicyOpen"
  (didDismiss)="isVendorPolicyOpen = false"
>
  <ng-template>
    <div class="inner-content"><ng-template [ngTemplateOutlet]="vendorPolicyContent"></ng-template></div>
  </ng-template>
</ion-modal>

<ion-modal
  class="vendor-policy"
  *ngIf="!isBrowser && policy"
  [isOpen]="isVendorPolicyOpen"
  (didDismiss)="isVendorPolicyOpen = false"
  [breakpoints]="[0, 0.35, 0.95]"
  [initialBreakpoint]="0.35"
>
  <ng-template>
    <ion-content><ng-template [ngTemplateOutlet]="vendorPolicyContent"></ng-template></ion-content>
  </ng-template>
</ion-modal>

<ng-template #vendorGroupsContent>
  <div class="vendor-group" *ngFor="let group of groupsSideMenuDetails">
    <div class="vendor-service-type-name" *ngIf="group.serviceTypeName">{{ group.serviceTypeName }}</div>
    <div
      tappable
      class="vendor-group-name"
      *ngFor="let groupItem of group.groups"
      (click)="onSelectGroupSideMenuOption(groupItem.tabIndex)"
    >
      {{ groupItem.name }}<span class="vendor-group-quantity" *ngIf="groupItem.itemsCount">{{ groupItem.itemsCount }}</span>
    </div>
  </div>
</ng-template>

<ion-modal
  class="vendor-groups auto-height"
  *ngIf="isBrowser && tabs?.length"
  [isOpen]="isVendorGroupsOpen"
  (didDismiss)="isVendorGroupsOpen = false"
>
  <ng-template>
    <div class="inner-content"><ng-template [ngTemplateOutlet]="vendorGroupsContent"></ng-template></div>
  </ng-template>
</ion-modal>

<ion-modal
  class="vendor-groups"
  *ngIf="!isBrowser && tabs?.length"
  [isOpen]="isVendorGroupsOpen"
  (didDismiss)="isVendorGroupsOpen = false"
  [breakpoints]="groupsSideMenuDetailsCount > 8 ? [0, 0.5, 1] : [0, 0.5, 0.95]"
  [initialBreakpoint]="0.5"
>
  <ng-template>
    <ion-content><ng-template [ngTemplateOutlet]="vendorGroupsContent"></ng-template></ion-content>
  </ng-template>
</ion-modal>
